import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { useHistory } from "react-router-dom";
import './index.css';
import { login } from "../../services/auth";
import api from '../../services/api_adiantamento';
import aiempresa from '../../services/api_lambda'
import { FaRegEyeSlash } from "react-icons/fa";
import logo from "./icone.png"


export default function Login() {
    if(document.getElementById('footer_empresa')) {
        document.getElementById('footer_empresa').innerHTML = '';
    }
    
    const [message, setMessage] = useState('');
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [type, setType] = useState('password');

    let history = useHistory();

    useEffect(() => {
        if (message !== '') {
            setUser('');
            setPassword('');
            setTimeout(() => {
                setMessage('');
            }, 3000);
        }
    }, [message])

    function onSubmit(event) {
        event.preventDefault();
        const data = { usuario: user, senha: password };
        api.post("/usuarios/login"
        , data
        ).then(function (response) {
            if (response.data) {
                if (response.data.erro) {
                    setMessage(response.data.erro);
                    return;
                } else {
                    localStorage.setItem('usuario_id', response.data.id);
                    localStorage.setItem('usuario', response.data.usuario);
                    if (password === '') {
                        history.push('/trocasenha');
                    } else {
                        history.push('/empresas');
                    }
                    return;
                }
            }
            throw new Error("Login inválido..")
        }).catch((e) => {
            setMessage(e.message)
        });
    }

    function showHidePassword() {
        if (type === 'text') {
            setType('password');
        } else if (type === 'password') {
            setType('text');
        }

    }

    return (
        <div className="login">
            <div className="col-md-4">
                <header className='header-login'>
                    <img className='img-logo' alt="logo" src={logo}></img>
                    <h1 className="text-center font-weight-bold">CONTROLADORIA</h1>
                </header>
                <div className="alerta">
                    {
                        message !== '' ? (
                            <Alert color="danger">{message}</Alert>
                        ) : ''
                    }
                </div>
                <form>
                    <div className="mb-2">
                        <input type="text" id="usuario" value={user} className="form-control" onChange={e => setUser(e.target.value)} placeholder="Usuario"></input>
                    </div>
                    <div className="login">
                        <input type={type} id="password" value={password} className="form-control mb-2" onChange={e => setPassword(e.target.value)} placeholder="Senha"></input>
                        <span className="lnr lnr-eye" onClick={showHidePassword}><FaRegEyeSlash size="30" /></span>
                        {/* onMouseDown={showPassword} onMouseUp={hidePassword} onMouseMove={hidePassword} */}
                    </div>
                    <div>
                        <button className="btn btn-primary" type="submit" onClick={onSubmit}>ENTRAR</button>
                    </div>
                </form>
            </div>
        </div>
    )
}